// Helper: build a schema.org BreadcrumbList for rich-result eligibility.
// Pass absolute URLs (https://afincalc.com/...) so Google resolves them
// correctly regardless of where the page is crawled from.
// Matches the visual breadcrumb shown on each page.

const SITE_ORIGIN = "https://afincalc.com";

const absolute = (path) => {
    if (!path) return SITE_ORIGIN + "/";
    if (path.startsWith("http")) return path;
    return SITE_ORIGIN + (path.startsWith("/") ? path : `/${path}`);
};

export function breadcrumbJsonLd(items) {
    return {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: items.map((item, i) => ({
            "@type": "ListItem",
            position: i + 1,
            name: item.name,
            item: absolute(item.path),
        })),
    };
}
